!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@adobe/aem-core-components-react-spa"] = t() : e["@adobe/aem-core-components-react-spa"] = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var t = {};
    function s(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, s), a.l = !0, a.exports;
    }
    return s.m = e, s.c = t, s.d = function (e, t, n) {
      s.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, s.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, s.t = function (e, t) {
      if (1 & t && (e = s(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (s.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) s.d(n, a, function (t) {
        return e[t];
      }.bind(null, a));
      return n;
    }, s.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return s.d(t, "a", t), t;
    }, s.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, s.p = "", s(s.s = 13);
  }([function (e, t) {
    e.exports = require("react");
  }, function (e, t) {
    e.exports = require("@adobe/aem-react-editable-components");
  }, function (e, t, s) {
    "use strict";

    s.d(t, "b", function () {
      return r;
    }), s.d(t, "a", function () {
      return i;
    });
    var n = s(0);
    const a = (() => {
        try {
          return "undefined" != typeof window;
        } catch (e) {
          return !1;
        }
      })(),
      r = (e, t) => s => {
        const a = s.baseCssClass,
          r = a && a.trim().length > 0 ? a : t,
          i = {
            ...s,
            baseCssClass: r
          };
        return n.createElement(e, Object.assign({}, i));
      },
      i = e => class extends n.Component {
        constructor(e) {
          super(e), this.state = {}, a && window.Granite && window.Granite.author && window.Granite.author.MessageChannel && (this.messageChannel = new window.Granite.author.MessageChannel("cqauthor", window), this.callback = this.callback.bind(this));
        }
        callback(e) {
          if (e.data && e.data.id === this.props.cqPath && "navigate" === e.data.operation) {
            const t = e.data.index;
            this.setState({
              activeIndexFromAuthorPanel: t
            });
          }
        }
        componentDidMount() {
          this.messageChannel && this.messageChannel.subscribeRequestMessage("cmp.panelcontainer", this.callback);
        }
        componentWillUnmount() {
          this.messageChannel && this.messageChannel.unsubscribeRequestMessage("cmp.panelcontainer", this.callback);
        }
        render() {
          return n.createElement(e, Object.assign({}, this.props, {
            activeIndexFromAuthorPanel: this.state.activeIndexFromAuthorPanel
          }));
        }
      };
  }, function (e, t, s) {
    "use strict";

    function n(e) {
      return !(null != e.elementsOrder && 0 !== e.elementsOrder.length || null != e.cqItemsOrder && 0 !== e.cqItemsOrder.length);
    }
    s.d(t, "a", function () {
      return n;
    });
  }, function (e, t, s) {
    "use strict";

    function n(e) {
      return null == e.cqItemsOrder || 0 == e.cqItemsOrder.length;
    }
    s.d(t, "a", function () {
      return n;
    });
  }, function (e, t, s) {
    "use strict";

    function n(e) {
      return null == e.cqItemsOrder || 0 === e.cqItemsOrder.length;
    }
    s.d(t, "a", function () {
      return n;
    });
  }, function (e, t, s) {
    "use strict";

    function n(e) {
      return null == e.cqItemsOrder || 0 === e.cqItemsOrder.length;
    }
    s.d(t, "a", function () {
      return n;
    });
  }, function (e, t, s) {
    "use strict";

    s.r(t);
    var n = s(0),
      a = s.n(n),
      r = s(1),
      i = s(2),
      o = s(6);
    class p extends r.Container {
      constructor(e) {
        super(e), this.state = {
          activeIndex: e.activeItem && e.activeItem.length > 0 ? this.props.cqItemsOrder.indexOf(e.activeItem) : 0,
          componentMapping: this.props.componentMapping || r.ComponentMapping
        }, this.handleTabNavClick = this.handleTabNavClick.bind(this);
      }
      componentDidUpdate(e, t, s) {
        void 0 !== this.props.activeIndexFromAuthorPanel && e.activeIndexFromAuthorPanel != this.props.activeIndexFromAuthorPanel && this.setState({
          activeIndex: this.props.activeIndexFromAuthorPanel
        });
      }
      tabbedChildComponents() {
        return !0 === this.props.isInEditor ? a.a.createElement(a.a.Fragment, null, this.childComponents.map((e, t) => {
          const s = {
            display: this.state.activeIndex === t ? "block" : "none"
          };
          return a.a.createElement("div", {
            key: "tab-content-" + t,
            className: this.props.baseCssClass + "__author-tab-content",
            style: s
          }, this.childComponents[t]);
        })) : this.childComponents[this.state.activeIndex];
      }
      handleTabNavClick(e) {
        this.state.activeIndex !== e && this.setState({
          activeIndex: e
        });
      }
      tabNavigation() {
        const e = [];
        return this.props.cqItems && this.props.cqItemsOrder ? a.a.createElement("ol", {
          role: "tablist",
          className: this.props.baseCssClass + "__tablist",
          "aria-label": this.props.accessibilityLabel,
          "aria-multiselectable": "false"
        }, this.props.cqItemsOrder.map((e, t) => {
          const s = this.props.cqItems[e],
            n = t === this.state.activeIndex;
          return a.a.createElement("li", {
            role: "tab",
            key: "tab-" + t,
            onClick: () => this.handleTabNavClick(t),
            className: this.props.baseCssClass + "__tab" + (n ? " " + this.props.baseCssClass + "__tab--active" : ""),
            tabIndex: n ? 0 : -1,
            "data-cmp-hook-tabs": "tab"
          }, s["cq:panelTitle"]);
        })) : e;
      }
      get tabContainerProps() {
        const e = this.containerProps;
        return e.className = e.className + " " + this.props.baseCssClass, e["data-cmp-is"] = "tabs", e["data-panelcontainer"] = "tabs", e;
      }
      render() {
        const e = Object(o.a)(this.props);
        return a.a.createElement("div", Object.assign({}, this.tabContainerProps), !e && this.tabNavigation(), !e && this.tabbedChildComponents(), this.placeholderComponent);
      }
    }
    t.default = Object(i.b)(Object(i.a)(p), "cmp-tabs");
  }, function (e, t, s) {
    "use strict";

    s.r(t);
    var n = s(0),
      a = s(2),
      r = s(1),
      i = s(4);
    class o extends r.Container {
      constructor(e) {
        super(e), this.state = {
          componentMapping: this.props.componentMapping || r.ComponentMapping,
          expandedItems: this.props.expandedItems
        }, this.handleAccordionNavClick = this.handleAccordionNavClick.bind(this);
      }
      componentDidUpdate(e, t) {
        void 0 !== this.props.activeIndexFromAuthorPanel && e.activeIndexFromAuthorPanel != this.props.activeIndexFromAuthorPanel && this.setState({
          expandedItems: [this.props.cqItemsOrder[this.props.activeIndexFromAuthorPanel]]
        });
      }
      handleAccordionNavClick(e) {
        const t = this.state.expandedItems.indexOf(e) > -1,
          s = this.props.singleExpansion;
        let n = this.state.expandedItems;
        if (s) n = t ? [] : [e];else if (t) {
          const t = this.state.expandedItems.indexOf(e);
          n.splice(t);
        } else n.push(e);
        this.setState({
          expandedItems: n
        });
      }
      isItemExpanded(e) {
        return this.state.expandedItems.indexOf(e) > -1;
      }
      get accordionContainerProps() {
        const e = this.containerProps;
        return e.className = e.className + " " + this.props.baseCssClass, e["data-cmp-is"] = "accordion", e["data-panelcontainer"] = "accordion", e;
      }
      displayItem(e, t) {
        const s = this.props.cqItemsOrder.indexOf(e);
        if (!0 === this.props.isInEditor || t) {
          const e = t ? `${this.props.baseCssClass}__panel ${this.props.baseCssClass}__panel--expanded` : `${this.props.baseCssClass}__panel ${this.props.baseCssClass}__panel--hidden`;
          return n.createElement("div", {
            className: e,
            role: "region"
          }, this.childComponents[s]);
        }
        return null;
      }
      renderHeadingButton(e, t, s) {
        return n.createElement("button", {
          className: s,
          onClick: () => {
            this.handleAccordionNavClick(e);
          }
        }, n.createElement("span", {
          className: this.props.baseCssClass + "__title"
        }, t["cq:panelTitle"]), n.createElement("span", {
          className: this.props.baseCssClass + "__icon"
        }));
      }
      get accordionContent() {
        return this.props.cqItemsOrder.map((e, t) => {
          const s = this.props.cqItems[e],
            a = this.isItemExpanded(e),
            r = a ? `${this.props.baseCssClass}__button ${this.props.baseCssClass}__button--expanded` : this.props.baseCssClass + "__button";
          return n.createElement("div", {
            key: "accordion-index" + t,
            className: this.props.baseCssClass + "__item",
            "data-cmp-index": t,
            "data-cmp-expanded": a
          }, n.createElement("" + (this.props.headingElement || "h3"), {
            className: this.props.baseCssClass + "__header"
          }, this.renderHeadingButton(e, s, r)), this.displayItem(e, a));
        });
      }
      render() {
        const e = Object(i.a)(this.props);
        return n.createElement("div", Object.assign({}, this.accordionContainerProps), !e && this.accordionContent, this.placeholderComponent);
      }
    }
    t.default = Object(a.b)(Object(a.a)(o), "cmp-accordion");
  }, function (e, t, s) {
    "use strict";

    s.r(t);
    var n = s(0),
      a = s.n(n),
      r = s(2),
      i = s(1),
      o = s(5);
    const p = (e, t) => {
      let s = e;
      for (let e = 0; e < t.length; e++) {
        const n = "{" + e + "}";
        s = s.replace(n, t[e]);
      }
      return s;
    };
    class l extends i.Container {
      constructor(e) {
        super(e), this.interval = 0, this.clearAutoPlay = () => {
          window.clearInterval(this.interval);
        }, this.state = {
          activeIndex: 0,
          isMouseEntered: !1,
          autoPlay: this.props.autoplay && !this.props.isInEditor,
          componentMapping: this.props.componentMapping || i.ComponentMapping
        }, this.handleIndicatorClick = this.handleIndicatorClick.bind(this), this.handleOnButtonPrev = this.handleOnButtonPrev.bind(this), this.handleOnButtonNext = this.handleOnButtonNext.bind(this), this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this), this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
      }
      componentDidUpdate(e, t, s) {
        void 0 !== this.props.activeIndexFromAuthorPanel && e.activeIndexFromAuthorPanel != this.props.activeIndexFromAuthorPanel && (this.setState({
          activeIndex: this.props.activeIndexFromAuthorPanel
        }), this.toggleAutoPlay(!1));
      }
      componentDidMount() {
        this.autoPlay();
      }
      componentWillUnmount() {
        this.interval && this.clearAutoPlay();
      }
      handleOnMouseEnter() {
        !this.props.autopauseDisabled && this.props.autoplay && this.clearAutoPlay();
      }
      handleOnMouseLeave() {
        !this.props.autopauseDisabled && this.props.autoplay && this.autoPlay();
      }
      handleOnButtonPrev() {
        this.prevSlide();
      }
      handleOnButtonNext() {
        this.nextSlide();
      }
      handleIndicatorClick(e) {
        this.state.activeIndex !== e && this.setState({
          activeIndex: e
        });
      }
      autoPlay() {
        this.interval = window.setInterval(() => {
          this.autoPlayTick();
        }, this.props.delay);
      }
      autoPlayTick() {
        !this.state.autoPlay || this.props.cqItemsOrder.length <= 1 || this.nextSlide();
      }
      toggleAutoPlay(e) {
        this.setState({
          autoPlay: e
        });
      }
      nextSlide() {
        const e = this.__getActiveIndex();
        e === this.props.cqItemsOrder.length - 1 ? this.__setSlide(0) : this.__setSlide(e + 1);
      }
      prevSlide() {
        const e = this.__getActiveIndex();
        0 === e ? this.__setSlide(this.props.cqItemsOrder.length - 1) : this.__setSlide(e - 1);
      }
      __getActiveIndex() {
        return this.state.activeIndex;
      }
      __setSlide(e) {
        this.setState({
          activeIndex: e
        });
      }
      render() {
        const e = Object(o.a)(this.props);
        return a.a.createElement("div", {
          className: this.props.baseCssClass,
          role: "group",
          "data-panelcontainer": "carousel",
          "aria-label": this.props.accessibilityLabel,
          "aria-roledescription": "carousel"
        }, !e && this.renderCarousel(), this.placeholderComponent);
      }
      displayItem(e, t) {
        const s = t === this.state.activeIndex,
          n = !(!s && !this.props.isInEditor),
          r = s ? `${this.props.baseCssClass}__item ${this.props.baseCssClass}__item--active` : this.props.baseCssClass + "__item",
          i = p(this.props.accessibility.slide, [(t + 1).toString(), this.props.cqItemsOrder.length.toString()]);
        return a.a.createElement("div", {
          key: "item-" + t,
          className: r,
          role: "tabpanel",
          "aria-label": i,
          "data-cmp-hook-carousel": "item"
        }, n && e);
      }
      renderCarousel() {
        return a.a.createElement("div", {
          className: this.props.baseCssClass + "__content",
          onMouseEnter: () => this.handleOnMouseEnter(),
          onMouseLeave: () => this.handleOnMouseLeave()
        }, this.childComponents.map((e, t) => this.displayItem(e, t)), this.renderCarouselActions(), this.renderCarouselIndicators());
      }
      renderCarouselIndicators() {
        return a.a.createElement("ol", {
          className: this.props.baseCssClass + "__indicators",
          role: "tablist",
          "aria-label": this.props.accessibility.indicators
        }, this.props.cqItemsOrder.map((e, t) => {
          const s = this.props.cqItems[e],
            n = t === this.state.activeIndex ? `${this.props.baseCssClass}__indicator ${this.props.baseCssClass}__indicator--active` : this.props.baseCssClass + "__indicator",
            r = p(this.props.accessibility.indicator, [(t + 1).toString()]);
          return a.a.createElement("li", {
            key: "item-" + t,
            onClick: () => this.handleIndicatorClick(t),
            className: n,
            role: "tab",
            "aria-label": r
          }, s["cq:panelTitle"]);
        }));
      }
      renderCarouselActions() {
        return a.a.createElement("div", {
          className: this.props.baseCssClass + "__actions"
        }, a.a.createElement("button", {
          onClick: () => this.handleOnButtonPrev(),
          className: `${this.props.baseCssClass}__action ${this.props.baseCssClass}__action--previous`,
          type: "button",
          "aria-label": this.props.accessibility.previous
        }, a.a.createElement("span", {
          className: this.props.baseCssClass + "__action-icon"
        }), a.a.createElement("span", {
          className: this.props.baseCssClass + "__action-text"
        }, this.props.accessibility.previous)), a.a.createElement("button", {
          onClick: () => this.handleOnButtonNext(),
          className: `${this.props.baseCssClass}__action ${this.props.baseCssClass}__action--next`,
          type: "button",
          "aria-label": this.props.accessibility.next
        }, a.a.createElement("span", {
          className: this.props.baseCssClass + "__action-icon"
        }), a.a.createElement("span", {
          className: this.props.baseCssClass + "__action-text"
        }, this.props.accessibility.next)), this.props.autoplay && a.a.createElement(a.a.Fragment, null, a.a.createElement("button", {
          className: `${this.props.baseCssClass}__action ${this.props.baseCssClass}__action--pause ` + (this.state.autoPlay ? "" : this.props.baseCssClass + "__action--disabled"),
          type: "button",
          "aria-label": this.props.accessibility.pause,
          onClick: () => this.toggleAutoPlay(!1)
        }, a.a.createElement("span", {
          className: this.props.baseCssClass + "__action-icon"
        }), a.a.createElement("span", {
          className: this.props.baseCssClass + "__action-text"
        }, this.props.accessibility.pause)), a.a.createElement("button", {
          className: `${this.props.baseCssClass}__action ${this.props.baseCssClass}__action--play ` + (this.state.autoPlay ? this.props.baseCssClass + "__action--disabled" : ""),
          type: "button",
          "aria-label": this.props.accessibility.play,
          onClick: () => this.toggleAutoPlay(!0)
        }, a.a.createElement("span", {
          className: this.props.baseCssClass + "__action-icon"
        }), a.a.createElement("span", {
          className: this.props.baseCssClass + "__action-text"
        }, this.props.accessibility.play))));
      }
    }
    l.defaultProps = {
      _allowedComponentPlaceholderListEmptyLabel: "CarouselV1",
      isInEditor: !1,
      autoplay: !1,
      cqPath: "",
      cqItems: {},
      cqItemsOrder: [],
      accessibilityLabel: "Carousel",
      accessibility: {
        play: "Play",
        pause: "Pause",
        next: "Next",
        previous: "Previous",
        slide: "Slide {0} of {1}",
        indicator: "Slide %{0}",
        indicators: "Choose a slide to display"
      }
    }, t.default = Object(r.b)(Object(r.a)(l), "cmp-carousel");
  }, function (e, t, s) {
    "use strict";

    s.r(t);
    var n = s(0),
      a = s.n(n),
      r = s(1),
      i = s(2);
    class o extends r.AllowedComponentsContainer {
      constructor(e) {
        super(e), this.state = {
          componentMapping: this.props.componentMapping || r.ComponentMapping
        }, this.mainDiv = a.a.createRef();
      }
      componentDidMount() {
        this.mainDiv.current && this.mainDiv.current.setAttribute("style", this.props.backgroundStyle);
      }
      componentDidUpdate() {
        this.mainDiv.current && this.mainDiv.current.setAttribute("style", this.props.backgroundStyle);
      }
      get coreContainerProps() {
        return {
          className: "container responsivegrid"
        };
      }
      render() {
        const {
          componentMapping: e,
          allowedComponents: t,
          children: s,
          cqPath: n,
          cqItems: i,
          cqItemsOrder: o,
          isInEditor: p,
          ...l
        } = this.props;
        if (p && t && t.applicable) return super.render();
        const c = {
          allowedComponents: {
            applicable: !1,
            components: []
          },
          componentMapping: this.state.componentMapping,
          gridClassNames: this.props.gridClassNames,
          columnClassNames: this.props.columnClassNames,
          cqItems: this.props.cqItems,
          cqItemsOrder: this.props.cqItemsOrder,
          title: "",
          cqPath: this.props.cqPath,
          isInEditor: !1
        };
        return a.a.createElement("div", Object.assign({}, this.coreContainerProps), a.a.createElement("div", {
          ref: this.mainDiv,
          id: this.props.id,
          className: this.props.baseCssClass
        }, this.props.layout && "simple" === this.props.layout && a.a.createElement(r.Container, {
          componentMapping: this.state.componentMapping,
          cqForceReload: this.props.cqForceReload,
          cqPath: this.props.cqPath,
          cqItems: this.props.cqItems,
          cqItemsOrder: this.props.cqItemsOrder,
          isInEditor: !1
        }), (!this.props.layout || "simple" !== this.props.layout) && a.a.createElement(r.ResponsiveGrid, Object.assign({}, c)), this.placeholderComponent));
      }
    }
    t.default = Object(i.b)(o, "cmp-container");
  }, function (e, t, s) {
    "use strict";

    s.r(t), s.d(t, "ContentFragmentV1IsEmptyFn", function () {
      return n.a;
    }), s.d(t, "MapToContentFragmentModel", function () {
      return o;
    }), s.d(t, "ContentFragmentRegistryV1", function () {
      return i;
    }), s.d(t, "DefaultContentFragmentV1Renderer", function () {
      return c;
    }), s.d(t, "ContentFragmentV1", function () {
      return u;
    });
    var n = s(3),
      a = s(1);
    class r {
      mapRenderer(e, t) {
        r.mapRenderer(e, t);
      }
      static mapRenderer(e, t) {
        if (e && t) {
          ("string" == typeof e ? [e] : e).forEach(e => {
            Object(a.MapTo)(this.getModelKey(e))(t);
          });
        }
      }
      getRenderer(e) {
        return r.getRenderer(e);
      }
      static getRenderer(e) {
        const t = this.getModelKey(e);
        return a.ComponentMapping.get(t);
      }
      static getModelKey(e) {
        return "ContentFragmentV1-" + e;
      }
    }
    var i = new r();
    const o = e => t => r.mapRenderer(e, t);
    var p = s(0),
      l = s.n(p);
    class c extends a.Container {
      renderElement(e, t, s) {
        return l.a.createElement("div", {
          key: this.props.id + "-element-" + e + "-" + s,
          className: this.props.baseCssClass + "__element"
        }, l.a.createElement("div", {
          className: this.props.baseCssClass + "__elemententry " + this.props.baseCssClass + "__elemententry--key"
        }, l.a.createElement("h4", null, t)), l.a.createElement("div", {
          className: this.props.baseCssClass + "__elemententry " + this.props.baseCssClass + "__elemententry--value"
        }, "value: ", e.value), l.a.createElement("div", {
          className: this.props.baseCssClass + "__elemententry " + this.props.baseCssClass + "__elemententry--datatype"
        }, "datatype: ", e.dataType), l.a.createElement("div", {
          className: this.props.baseCssClass + "__elemententry " + this.props.baseCssClass + "__elemententry--multivalue"
        }, "multivalue: ", e.multiValue ? "true" : "false"), l.a.createElement("div", {
          className: this.props.baseCssClass + "__elemententry " + this.props.baseCssClass + "__elemententry--type"
        }, "type: ", e[":type"]));
      }
      get elements() {
        return l.a.createElement("div", {
          className: this.props.baseCssClass + "__elements"
        }, this.props.elementsOrder.map((e, t) => this.renderElement(this.props.elements[e], e, t)), ";");
      }
      render() {
        return l.a.createElement("div", {
          id: this.props.id,
          className: this.props.baseCssClass
        }, l.a.createElement("h3", {
          className: this.props.baseCssClass + "__title"
        }, this.props.title), !!this.props.description && this.props.description.length > 0 && l.a.createElement("p", {
          className: this.props.baseCssClass + "__description"
        }, this.props.description), this.props.elementsOrder && this.props.elementsOrder.length && this.elements, this.childComponents);
      }
    }
    var d = s(2);
    class h extends a.Container {
      constructor(e) {
        super(e), this.state = {
          componentMapping: this.props.componentMapping || a.ComponentMapping
        };
      }
      get renderEmptyPlaceHolder() {
        return this.props.isInEditor ? l.a.createElement("div", {
          className: "cf-placeholder"
        }, "ContentFragment is empty.") : l.a.createElement(l.a.Fragment, null);
      }
      render() {
        if (Object(n.a)(this.props)) return this.renderEmptyPlaceHolder;
        let e = i.getRenderer(this.props.model);
        return e || (e = Object(d.b)(c, "cmp-contentfragment")), l.a.createElement(e, Object.assign({}, this.props, {
          componentMapping: this.state.componentMapping
        }));
      }
    }
    var u = h;
  }, function (e, t, s) {
    "use strict";

    s.r(t), s.d(t, "AccordionV1IsEmptyFn", function () {
      return n.a;
    }), s.d(t, "ContainerV1IsEmptyFn", function () {
      return a;
    }), s.d(t, "CarouselV1IsEmptyFn", function () {
      return r.a;
    }), s.d(t, "TabsV1IsEmptyFn", function () {
      return i.a;
    }), s.d(t, "ContentFragmentV1IsEmptyFn", function () {
      return o.a;
    });
    var n = s(4);
    function a(e) {
      return null == e.cqItemsOrder || 0 === e.cqItemsOrder.length;
    }
    var r = s(5),
      i = s(6),
      o = s(3);
  }, function (e, t, s) {
    e.exports = s(14);
  }, function (e, t, s) {
    "use strict";

    s.r(t);
    var n = s(2);
    s.d(t, "withStandardBaseCssClass", function () {
      return n.b;
    }), s.d(t, "withAuthorPanelSwitch", function () {
      return n.a;
    });
    var a = s(12);
    s.d(t, "AccordionV1IsEmptyFn", function () {
      return a.AccordionV1IsEmptyFn;
    }), s.d(t, "ContainerV1IsEmptyFn", function () {
      return a.ContainerV1IsEmptyFn;
    }), s.d(t, "CarouselV1IsEmptyFn", function () {
      return a.CarouselV1IsEmptyFn;
    }), s.d(t, "TabsV1IsEmptyFn", function () {
      return a.TabsV1IsEmptyFn;
    }), s.d(t, "ContentFragmentV1IsEmptyFn", function () {
      return a.ContentFragmentV1IsEmptyFn;
    });
    var r = s(7);
    s.d(t, "TabsV1", function () {
      return r.default;
    });
    var i = s(8);
    s.d(t, "AccordionV1", function () {
      return i.default;
    });
    var o = s(9);
    s.d(t, "CarouselV1", function () {
      return o.default;
    });
    var p = s(10);
    s.d(t, "ContainerV1", function () {
      return p.default;
    });
    var l = s(11);
    s.d(t, "MapToContentFragmentModel", function () {
      return l.MapToContentFragmentModel;
    }), s.d(t, "ContentFragmentRegistryV1", function () {
      return l.ContentFragmentRegistryV1;
    }), s.d(t, "DefaultContentFragmentV1Renderer", function () {
      return l.DefaultContentFragmentV1Renderer;
    }), s.d(t, "ContentFragmentV1", function () {
      return l.ContentFragmentV1;
    });
  }]);
});